import React from "react";
import {useState} from "react";
import { Tooltip } from "reactstrap";

const VenueDetailInformation: React.FC<any> = (props: any) => {
  const [locationTooltipOpen, setLocationTooltipOpen] = useState<boolean>(false);
  const locationToggle = () => setLocationTooltipOpen(!locationTooltipOpen);
  const [infoTooltipOpen, setInfoTooltipOpen] = useState<boolean>(false);
  const infoToggle = () => setInfoTooltipOpen(!infoTooltipOpen);
  
  return (
    <div>
      <div className="row mt-4">
        <div className="col-1 py-0 pl-2 pr-0">
          <img
            src={require("../../../assets/img/ic_map.png")}
            alt="Icona ubicació"
            className="mr-3 img-fluid mx-auto d-block"
            id="locationTooltip"
          />
          <Tooltip
            placement="top"
            isOpen={locationTooltipOpen}
            target="locationTooltip"
            toggle={locationToggle}
            hideArrow={true}
            style={{ backgroundColor: "#7c7c7c" }}
          >
            Ubicació
          </Tooltip>
        </div>
        <span className="col-11 mb-0  lh-125  ">
          <span>
            {props.venue?.address}
            <br></br>
            {props.venue?.postalCode} {props.venue?.city}
            <br></br>
            {props.venue?.phone}
          </span>{" "}
        </span>
      </div>
      <hr className="my-3" />
      <div className="row">
        <div className="col-1 py-0 pl-2 pr-0">
          <img
            src={require("../../../assets/img/ic_info.png")}
            alt="Icona ubicació"
            className="mr-3 img-fluid mx-auto d-block"
            id="infoTooltip"
          />
          <Tooltip
            placement="top"
            isOpen={infoTooltipOpen}
            target="infoTooltip"
            toggle={infoToggle}
            hideArrow={true}
            style={{ backgroundColor: "#7c7c7c" }}
          >
            Informació
          </Tooltip>
        </div>
        <span className="col-11 mb-0  lh-125 mt-1 ">
          {props.venue.description &&
            (props.venue.description != null ||
              props.venue.description !== "") && (
              <div>
                <div
                  dangerouslySetInnerHTML={{ __html: props.venue?.description }}
                />
                <br />
              </div>
            )}
          {!!props.venue.moreInfoUrl?.trim() && (
            <a
              href={props.venue.moreInfoUrl}
              target="_new"
              className="btn btn-sm btn-primary px-3 mb-2 mr-4 rounded-button"
            >
              Més informació
            </a>
          )}

          {!!props.venue.mapUrl?.trim() && (
            <a
              href={props.venue.mapUrl}
              target="_new"
              className="btn btn-sm btn-primary px-3 mb-2 rounded-button"
            >
              Ubicació
            </a>
          )}
        </span>
      </div>
    </div>
  );
};

export default VenueDetailInformation;
